import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";
import { handleApiError } from "../scopedListFetch";

export const getContactDetails = async (contactId) => {
  const ROUTE = urlConfig.backend.routes.contacts.getContactDetails;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .get(url, {
      params: { id: contactId },
    })
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something Went Wrong please try again later",
      };
    })
    .catch((error) => handleApiError(error));
};
